import type { Lesson, UserLesson } from '@/types';

/**
 * Whether to skip the lesson preview modal/sheet and go directly to the lesson.
 * True when user has watched (left_off_at > 0) or when summary is visible in list view.
 */
export function shouldSkipPreview(
  lesson: Lesson,
  userLessonsMap: Record<number, UserLesson>,
  options?: { viewMode?: 'grid' | 'list'; includeSummaryVisible?: boolean }
): boolean {
  const userLesson = userLessonsMap[lesson.id];
  const hasWatched = userLesson && (userLesson.left_off_at_seconds ?? 0) > 0;
  if (hasWatched) return true;
  if (
    options?.includeSummaryVisible &&
    options.viewMode === 'list' &&
    !!lesson.summary
  ) {
    return true;
  }
  return false;
}
